import {OrderStore} from "@/store/order";
import {shallow} from "zustand/shallow";

export const useOrdersContext = () => {
  const context = OrderStore(state => state, shallow);

  if (!context) throw new Error('OrdersContext context must be use inside OrderProvider');

  return context;
};
